export enum OmniPageName {
  Home = 'JetBlue | Home Page',
  signin = 'JetBlue | SignIn Page',
  flighttracker = 'JetBlue | Flight Tracker Page',
  flightsdestination = 'JetBlue | Flights Destination Page',
  NoResultPage = 'JetBlue | No Results',
}
